import { render, staticRenderFns } from "./LoginSetting.vue?vue&type=template&id=280bde46&scoped=true"
import script from "./LoginSetting.vue?vue&type=script&lang=js"
export * from "./LoginSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280bde46",
  null
  
)

export default component.exports